import { pxToRem, themeGet, unit } from '@pocketlaw/tetris';
import styled from 'styled-components';
export const AccordionDivider = styled.div `
  margin: 0 -${unit('xl')};
  width: calc(100% + ${unit('3xl')});
  height: ${pxToRem(1)};
  background-color: ${themeGet('colors.gray.100')};
`;
